// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

/**
 * Yüklemede "CORS / preflight" görürseniz: tarayıcı aslında 403/404 gizler.
 * 1) Google Cloud Console → APIs & Services → Credentials → bu API anahtarı →
 *    "Application restrictions" / "Website restrictions" localhost yoksa ekleyin:
 *    http://localhost:3000/* ve http://127.0.0.1:3000/*
 * 2) Firebase → Storage → Rules: watches/ için allow write yayınlandı mı?
 * 3) storageBucket, Firebase Console → Project settings → config ile birebir aynı olsun.
 */
const firebaseConfig = {
    apiKey: "AIzaSyBJGYYTCBc0FB8qfcXKAj9zMQLHZpYuDSY",
    authDomain: "kain-baf12.firebaseapp.com",
    projectId: "kain-baf12",
    storageBucket: "kain-baf12.firebasestorage.app",
    messagingSenderId: "88862828910",
    appId: "1:88862828910:web:52553b6ac2274b00e7797f",
    measurementId: "G-91GT5K2ZL9"
  };

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);

export { db, storage }; 